import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { AddAssetToSceneWizardPage } from './add-asset-to-scene-wizard.page';
import { NewAssetSidebarComponent } from './new-asset-sidebar/new-asset-sidebar.component';
import { NewAssetDescriptionComponent } from './new-asset-description/new-asset-description.component';
import { NewAssetCardComponent } from './new-asset-sidebar/new-asset-card/new-asset-card.component';
import { AddAssetToSceneHelpComponent } from './add-asset-to-scene-help/add-asset-to-scene-help.component';

const routes: Routes = [
  {
    path: '',
    component: AddAssetToSceneWizardPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [
    AddAssetToSceneWizardPage,
    NewAssetSidebarComponent,
    NewAssetDescriptionComponent,
    NewAssetCardComponent,
    AddAssetToSceneHelpComponent
  ]
})
export class AddAssetToSceneWizardPageModule { }
